import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useMyStore } from '@/v2/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'CountrySelectTo',
  setup(__props) {

const store = useMyStore();
store.loadCountries();

/**
 * Filter for country search
 *
 * @param {string} input -> search value
 * @param {{value: string}} option -> select item
 * @returns {boolean}
 */
const countriesFilterOption = (
  input: string,
  option: {
    key: string;
  }
): boolean => {
  return option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    loading: _unref(store).loading > 0,
    ref: "countrySelect",
    "show-search": "",
    size: "large",
    class: "base-country-select",
    options: _unref(store).state.countries,
    placeholder: _ctx.$t('shippingDetailsLocation_destination_placeholder'),
    onChange: _unref(store).changeCountry,
    "filter-option": countriesFilterOption
  }, null, 8, ["loading", "options", "placeholder", "onChange"]))
}
}

})